export enum OpenPaymentsAnalyticsEnum {
  VIEW_NOTICE = '[PAC WEB] Pagamentos Pendentes - Visualizou aviso',
  OPEN_LIST = '[PAC WEB] Pagamentos Pendentes - Abriu lista',
  RESUME_PAYMENT = '[PAC WEB] Pagamentos Pendentes - Retomou pagamento',
  CANCEL_PAYMENT = '[PAC WEB] Pagamentos Pendentes - Cancelou pedido',
}

export enum OpenPaymentsOrigin {
  NOTICE = 'aviso',
  HEADER = 'icone_header',
}

export const OPEN_PAYMENTS_ORIGIN_PARAM = 'origem';
